export enum FileDownloadStatusEnum {
  Pending = 'Pending',
  Success = 'Success',
  PartialSuccess = 'PartialSuccess',
  Failed = 'Failed',
  Processing = 'Processing',
  Verifying = 'Verifying',
  IntegrityCheckFailed = 'IntegrityCheckFailed',
}
